module.exports = __webpack_public_path__ + "static/img/email.9505e13.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/email.png
// module id = vCvB
// module chunks = 1